import { get } from 'lodash';
import {
  MS_PHASE_3_ENDPOINTS,
  financeService,
} from 'utils/msEndpointConstants';

const { FINANCE } = MS_PHASE_3_ENDPOINTS;

export const getFeeTierByRegId = regId => {
  if (!regId) {
    return Promise.resolve({});
  }
  return financeService()
    .get(FINANCE.getFeeTierByRegistrationId(regId))
    .then(r => get(r, 'data', {}))
    .catch(() => ({}));
};

export default { getFeeTierByRegId };
